export namespace AriaTokens {
  export const ONDC_NOTES_INTEGRATION_ARIA_TENANT = '41701a0d2ecf4ad6a3d47b4352bf3937-72a6ba9b-e632-47e4-9ccc-5052f6190c5c-6927'
}

export namespace OTelTokens {
  export const ONENOTE_NEXUS_TENANT_TOKEN = 1718
  export const ONDC_NOTES_INTEGRATION_OTEL_TENANT = '6c530cfc6dd549f2a4a3e0e3c8cfdd22-28a36521-61fe-4559-a47b-5d98803a2f60-7312'
}
